import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonModule as NimbusCommonModule } from '../common/common.module';
import { BrandingLogoComponent } from './branding-logo.component';

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
  ],
  exports: [
    BrandingLogoComponent,
  ],
  declarations: [
    BrandingLogoComponent,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BrandingModule { }

